module.exports = __webpack_public_path__ + "img/r_hone_icon_03.1bfa8419.png";